export default {
  reset: (state) => {
    state.item = {
      course: null,
      tag: null,
      amount: null,
      days: null,
      codes: [],
    };
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};
